import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

interface IHolidayPostData {
  id?: string;
  name: string;
  on_calendar?: boolean;
  start_date: string;
  end_date: string;
  active: boolean;
  user_ids: Array<number>;
}

const saveHoliday = ({ id, ...postData }: IHolidayPostData) => {
  if (id) {
    return http().put(endpoints.timeOff.holidayById.replace('{id}', id), postData);
  }
  return http().post(endpoints.timeOff.holidays, postData);
};

export function useSaveHoliday() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveHoliday,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries(['fetchPaginatedHolidays']);
      }
    },
  });
}
